var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscendingDescendingSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 8.25C10.3099 8.25 10.1199 8.18 9.96994 8.03L7.99994 6.06L6.02994 8.03C5.73994 8.32 5.25994 8.32 4.96994 8.03C4.67994 7.74 4.67994 7.26 4.96994 6.97L7.46994 4.47C7.75994 4.18 8.23994 4.18 8.52994 4.47L11.0299 6.97C11.3199 7.26 11.3199 7.74 11.0299 8.03C10.8799 8.18 10.6899 8.25 10.4999 8.25Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.75C7.59 19.75 7.25 19.41 7.25 19V5C7.25 4.59 7.59 4.25 8 4.25C8.41 4.25 8.75 4.59 8.75 5V19C8.75 19.41 8.41 19.75 8 19.75ZM16 19.75C15.81 19.75 15.62 19.68 15.47 19.53L12.97 17.03C12.68 16.74 12.68 16.26 12.97 15.97C13.26 15.68 13.74 15.68 14.03 15.97L16 17.94L17.97 15.97C18.26 15.68 18.74 15.68 19.03 15.97C19.32 16.26 19.32 16.74 19.03 17.03L16.53 19.53C16.38 19.68 16.19 19.75 16 19.75Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.75C15.59 19.75 15.25 19.41 15.25 19V5C15.25 4.59 15.59 4.25 16 4.25C16.41 4.25 16.75 4.59 16.75 5V19C16.75 19.41 16.41 19.75 16 19.75Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingDescendingSortIcon);
export default __webpack_public_path__ + "static/media/AscendingDescendingSortIcon.c8dd8b3169f92b98d68539151ca016ed.svg";
export { ForwardRef as ReactComponent };